import React from 'react';
import styled from 'styled-components';
import Checkbox from '../Checkbox';

import Radio from '../Radio';

const CardContainer = styled.div<{ disable: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: ${props => (props.disable ? 'not-allowed' : 'pointer')};
  border-radius: 8px;
  box-shadow: 0px 8px 20px 0px #0000000f;
  opacity: ${props => (props.disable ? '60%' : '100%')};

  & + & {
    margin-top: 16px;
  }

  .icon-wrapper {
    background-color: #f2f6f9;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const CardTitleContainer = styled.div<{ iconWrapper: boolean }>`
  display: grid;
  grid-template-columns: ${props => (props.iconWrapper ? '1fr 4fr' : '1fr')};
  align-items: center;
  width: 100%;
  padding: 16px 0 16px 16px;

  .img-with-wrapper {
    display: inline-block;
    width: 30px;
    border-radius: 30px;
  }

  .img-without-wrapper {
    display: inline-block;
    width: 40px;
    border-radius: 30px;
  }

  & .info {
    display: flex;
    align-items: left;
    flex-direction: column;

    & .title {
      display: inline-block;
      margin: 0;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: var(--color-gray-500);
    }

    & .description {
      margin: 0;
      color: var(--color-gray-400);
      font-size: 14px;
      font-weight: 400;
    }
  }

  & .radio {
    margin-left: auto;
  }
`;

const CustomCheck = styled(Checkbox)`
  padding: 16px 16px 16px 0;
  cursor: pointer;
`;

export interface TypeCardProps {
  onClick: () => void;
  iconSrc?: string;
  iconWrapper?: boolean;
  checked: boolean;
  disable?: boolean;
  title: string;
  description?: string;
}

export const TypeCardCheck: React.FC<TypeCardProps> = ({
  onClick,
  iconSrc,
  iconWrapper,
  checked,
  title,
  description,
  disable
}) => {
  return (
    <CardContainer disable={!!disable}>
      <CardTitleContainer iconWrapper={!!iconWrapper} onClick={onClick}>
        {iconSrc && iconWrapper && (
          <div className="icon-wrapper">
            <img className="img-with-wrapper" src={iconSrc} alt="an icon" />
          </div>
        )}
        {iconSrc && !iconWrapper && <img className="img-without-wrapper" src={iconSrc} alt="an icon" />}
        <div className="info">
          <p className="title">{title}</p>
          {!!description && <p className="description">{description}</p>}
        </div>
      </CardTitleContainer>
      <CustomCheck checked={checked} onChange={onClick} />
    </CardContainer>
  );
};
